import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class ChartsService {

  constructor(private http: HttpClient) { }

  getStrikeSkewData(params, tabType: string, prefix?: string): Observable<any> {
    return this.http
      .get(
        `${tabType === 'instrument' ? '/options-monitor' : '/futures-options-monitor'}/charts/strikeSkew${prefix}`,
        {observe: 'response', params}
      );
  }

  getTimeSkewData(params, tabType: string, prefix?: string): Observable<any> {
    return this.http
      .get(
        `${tabType === 'instrument' ? '/options-monitor' : '/futures-options-monitor'}/charts/timeSkew${prefix}`,
        {observe: 'response', params}
      );
  }

  getDeltaSurfaceData(stockId: any, regionId: any, type: string, delta: number[]): Promise<any> {
    let params = new HttpParams().append('stockId', stockId)
      .append('regionId', regionId)
      .append('type', type);
    for (let i = 0; i < delta.length; i++) {
      params = params.append('delta', String(delta[i]));
    }

    return this.http
      .get('/charts/deltaSurfaceChart', {params: params})
      .toPromise()
      .then(response => response, () => [])
      .catch(this.handleError);
  }

  getData(id: any, type: any, prefix: string, mode: string, tabType: string): Observable<any> {
    const params = new HttpParams()
      .append(tabType === 'instrument' ? 'stockId' : 'underlyingId', id)
      .append('type', type);

    if (tabType === 'instrument') {
      params.append('isDelayed', String(!(mode === 'rt')));
    }

    return this.http
      .get(
        `${tabType === 'instrument' ? '/options-monitor' : '/futures-options-monitor'}/charts/volatilitySurface${prefix}`,
        {observe: 'response', params});
  }

  public getFutCurve(params): Observable<any> {
    return this.http.get('/futures-options-monitor/charts/futCurve', {observe: 'response', params});
  }

  getIVXChartData(instrument: any): Observable<any> {
    const params = new HttpParams().append('stockId', instrument);
    return this.http
      .get('/ivx-monitor/registry/chart', {params: params});
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); // for demo purposes only
    return Promise.reject(error.message || error);
  }
}
